import * as types from '../../constants/rmg/TournamentActionTypes'
import {env} from '../../constants/Environment';
import {url} from '../../constants/rmg/settings';
import _ from 'lodash';

export function load(sportId, categoryId){
	return async function(dispatch){
        dispatch({
            type: types.REQUEST,
            id: [sportId, categoryId]
        });

        const response = await fetch(url + '/sports/' + sportId + '/categories/' + categoryId + '/tournaments');
        const result = await response.json();

        dispatch({
            type: types.RECEIVE,
            data: result.tournaments,
            id: [sportId, categoryId]
        })
    }
}